export const Modules = Object.freeze([
  { id: 1, description: "Community Manager" },
  { id: 2, description: "Canal digital" },
  { id: 3, description: "Asesores de venta" },
  { id: 4, description: "Matriz" },
  { id: 5, description: "MAF" },
  { id: 6, description: "Conexos" },
  { id: 7, description: "Licitaciones" },
  { id: 8, description: "ADV" },
  { id: 9, description: "Inmatriculaciones" },
  { id: 10, description: "PDS" },
  { id: 11, description: "Autotuning" },
  { id: 12, description: "Citas" },
  { id: 13, description: "Comisiones" },
  { id: 14, description: "Seminuevos" },
  { id: 15, description: "Almacenero" },
  { id: 16, description: "Finanzas" },
  { id: 17, description: "Vehículos" },
  { id: 18, description: "Aprovisionamiento" },
  { id: 19, description: "Control de ingresos" },
  { id: 20, description: "Ventas" },
  { id: 21, description: "CRM" },
  { id: 22, description: "Lavado de activos" },
  { id: 23, description: "Traslados" },
  { id: 24, description: "Cajero Conexos" },
]);
